import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Standard shadcn-style class-name combinator. Use everywhere class lists are
 * built conditionally — combines clsx's ergonomics with tailwind-merge's
 * conflict-resolution (so `cn('p-2', isLarge && 'p-4')` actually drops the p-2).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
